export default __webpack_public_path__ + "static/media/image-4.66ca939d.webp";